export default function (req, res, next) {
  if (req.url.startsWith('/slide/')) {
    res.statusCode = 403
    res.end('Forbidden')
  } else {
    next()
  }
}
